export default {"src":"/_next/static/media/webinar-3.bb9b0f6a.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};